import React from 'react'
import Footer from './components/footer'
import PDF from  './img/kiviArticleFeb2020.pdf'

function About(){
	return(
		<><section class="intro-single">
		<div class="container">
		  <div class="row">
			<div class="col-md-12 col-lg-12">
			  <div class="title-single-box">
				<h1 class="title-single">About Us</h1>
			

			  </div><br/>
			 <div class="card">
    <div class="card-body"> <b>How long you are in the service of hearing aids? </b>
	 <br/>
	Since 2011, I'm in hearing aid service 
	</div>
  </div>
  <div class="card bg-light text-dark">
    <div class="card-body"> <b>How did you learn about it? </b>
	  
	<p> As an electronic student i was more interested in gadgets, and i was working in other electronic devices before hearing aids. Later on when i knew about hearing aids, i was very much interested and started learing more about  it which made me clear that this is my field of interest. </p>
	<p>
Firstly when i Joined PhonakIndiaPvt Ltd a switzerland based company, i got a complete training of hearing aid repairs and custom making and continued to work in phonak for 2 years, later i have joined to GN Resound India Pvt Ltd  Denmark based company for  5 years , after getting enough experience I've started  my own lab for mould making and hearing aid service of multibrand.
</p>
	</div>
  </div><div class="card">
    <div class="card-body"> <b>With whom are you associated with: </b>
	 <br/>
	 ReSounda provider of hearing aids and accessories, represented in more than 100 countries. Headquartered in Ballerup, Denmark, ReSound is part of GN Store Nord.
	</div>
  </div>
  <div class="card bg-light text-dark">
    <div class="card-body"> <b>What is the reason for people going deaf, as per you? </b>
	<p>There are many reasons for  people going deaf,one of the main reason for people going deaf  is loud noises. Listening to loud music through earphones and headphones is one of the biggest dangers to your hearing.</p>
	<p>Hearing loss may also result from genetic causes, complications at birth, certain infectious diseases, chronic ear infections, the use of particular drugs, exposure to excessive noise, and ageing. </p>
	
	
	</div>
  </div>
  <div class="card">
    <div class="card-body"> <b>What  precautions are needed while using hearing aids? </b>
	<p>There are many reasons for  people going deaf,one of the main reason for people going deaf  is loud noises. Listening to loud music through earphones and headphones is one of the biggest dangers to your hearing.</p>
	<p>Hearing loss may also result from genetic causes, complications at birth, certain infectious diseases, chronic ear infections, the use of particular drugs, exposure to excessive noise, and ageing. </p>
	
	
	</div>
  </div>
  <div class="card bg-light text-dark">
    <div class="card-body"> <b>What is the reason for people going deaf, as per you? </b>
	 <p>
	 Keep hearing aids away from heat and moisture.
Replace dead batteries immediately.
Clean hearing aids as instructed.
Do not use hairspray or other hair care products while wearing hearing aids.

	 </p>
	 <p>Turn off hearing aids when they are not in use.
Keep replacement batteries and small aids away from children and pets.
Be careful not to drop the hearing aid.
</p>
	
	
	</div>
  </div>
  <div class="card">
    <div class="card-body"> <b>Is there enough schools for hearing aids? </b>
	 <p>
	 Yes there are many hearings institutions in like The Sheila Kothavala Institute For The Deaf,Dr. S. R. Chandrasekhar Institute Of Speech And Hearing, All india institute of speech and hearing.
	 </p>
	  <p>
	  I have been associated with Sheila Kothavala Institute For The Deaf  for past 3 years and giving my best to service , repair and provide solutions  for the hearing impaired children And I'm looking forward to work with more such instititions.
	  </p>
	
	
	</div>
  </div>
  <div class="card bg-light text-dark">
    <div class="card-body"> <b>How costly or cheap are hearing aids? </b>
	<p>The average cost of one digital hearing aid can range from Rs10,000 to Rs20,000. The cheapest hearing aids costs  between Rs7,500 to Rs.15,000. Midrange hearing aids costs  from Rs20,000 to 2,5000. Premium hearing aids fall in the range of Rs25000 to RS50,000 per device.</p>
	  
	
	
	</div>
  </div>
  <div class="card">
    <div class="card-body"> <b>Does government give assistance in buying hearing aids? </b>
	 <p>Yes our government does give assistance for poor people in buying hearing aids, for example ADIP scheme.</p> 
	
	
	</div>
  </div>
  <div class="card bg-light text-dark">
    <div class="card-body"> <b>Are you doing service of hearing aids, throughout Karnataka or India?</b>
	 <p>I'm doing service of hearing aids throughout  karnataka and also Kerala, Mumbai and tamilnadu.</p> 
	
	
	</div>
  </div>
  <div class="card">
    <div class="card-body"> <b>If any government schools or private schools contact you for servicing their students’ hearing aids, will you be able to take up?</b>
	 <p>Yes and i will be glad to assist them , and I would be giving special discounted price for the same.</p>
	
	</div>
  </div>
  <div class="card bg-light text-dark">
    <div class="card-body"> <b>Anything else about yourself or your activity?</b>
 <p>I am looking forward to help poor people with their hearing problems, assist them and give them best solutions. Other than making hearing moulds, i'm also making swimming plug, CIC Shell, ITC Shell, ITE Shell. </p>
	
	</div>
  </div>
  <div class="card">
    <div class="card-body"> <b>Any message for hearing aid users? </b>
  <p>Please contact me for any hearing aid services, i would be giving you the fast and best service with a special discounted price. </p>
	</div>
  </div>
			</div>
			 </div>
			</div> </section>
	 <Footer/></>
)
	}
	
export default About